// Returns the appropriate step size, in meters, to use for an axis.
//
function calculateStepSize(minValue, maxValue, maxSteps) {
  let candidateStepSizes = [1, 2, 5];
  let candidateStepSize;
  let i = 0;
  let stepCount = null;

  do {
    if (i >= candidateStepSizes.length) {
      i = 0;
      for(var j = 0; j < candidateStepSizes.length; j++) {
        candidateStepSizes[j] *= 10;
      }
    }
    candidateStepSize = candidateStepSizes[i++];
    stepCount = (maxValue - minValue) / candidateStepSize;
  } while (stepCount > maxSteps);
  return candidateStepSize;
}

export { calculateStepSize };
